var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pageData.wells && _vm.pageData.wells.length > 0
    ? _c(
        "div",
        { staticClass: "point-page" },
        [
          _c(
            "el-collapse",
            { staticClass: "home-msg_collapse", attrs: { accordion: "" } },
            [
              _c(
                "el-collapse-item",
                [
                  _c("template", { slot: "title" }, [
                    _c(
                      "div",
                      { staticClass: "spaceLeft home-msg_collapse_head" },
                      [
                        _c(
                          "div",
                          [
                            _c("svg-icon", {
                              staticClass: "icon-arrow",
                              attrs: { "icon-class": "tn-down" },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Measurement Point " +
                                  _vm._s(_vm.pointIndex + 1)
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "pageForm",
                          staticClass: "page-form point-form",
                          attrs: {
                            model: _vm.pageData,
                            "label-position": "left",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 40 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "location_id",
                                        label:
                                          "location_id of Measurement Point",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.pageData.location_id) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "location",
                                        label: "location of Measurement Point",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.pageData.location) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.pageData.wells, function (well, index) {
                        return [
                          _c(
                            "el-collapse",
                            {
                              key: index,
                              staticClass: "sub-collapse",
                              attrs: { accordion: "" },
                            },
                            [
                              _c(
                                "el-collapse-item",
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "spaceLeft sub-collapse_head",
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("svg-icon", {
                                              staticClass: "icon-arrow",
                                              attrs: {
                                                "icon-class": "tn-down",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "well " +
                                                  _vm._s(
                                                    _vm.pointIndex +
                                                      1 +
                                                      "-" +
                                                      (index + 1)
                                                  )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form",
                                    {
                                      ref: "pageWellForm",
                                      refInFor: true,
                                      staticClass: "page-form point-form",
                                      attrs: {
                                        rules: _vm.annualReview
                                          ? _vm.pageWellRules
                                          : {},
                                        model: well,
                                        "label-position": "left",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 40 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "location_id",
                                                    label: "location_id:",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(well.location_id) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "location",
                                                    label:
                                                      "location of Measurement Point",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(well.location) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "aerLicensee",
                                                    label: "AER Licensee:",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(well.aerLicensee) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "aerLicenseNo",
                                                    label: "AER License No:",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        well.aerLicenseNo
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "aerSurfaceLocation",
                                                    label:
                                                      "AER surface location",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        well.aerSurfaceLocation
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "UWI",
                                                    label: "AER UWI:",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(well.UWI) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "fromToIDIdentifier",
                                                    label:
                                                      "FromToIDIdentifier:",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        well.fromToIDIdentifier
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "sulphur",
                                                    label: "Sulphur Content:",
                                                  },
                                                },
                                                [
                                                  !_vm.annualReview
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(well.sulphur) +
                                                            " %"
                                                        ),
                                                      ])
                                                    : _c(
                                                        "el-input",
                                                        {
                                                          staticStyle: {
                                                            width: "2rem",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            "auto-complete":
                                                              "off",
                                                            placeholder:
                                                              "Please fill in",
                                                          },
                                                          model: {
                                                            value: well.sulphur,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                well,
                                                                "sulphur",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "well.sulphur",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [_vm._v("%")]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "APIGravity",
                                                    label: "API Gravity:",
                                                  },
                                                },
                                                [
                                                  !_vm.annualReview
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              well.APIGravity
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ])
                                                    : _c("el-input", {
                                                        staticStyle: {
                                                          width: "2rem",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          "auto-complete":
                                                            "off",
                                                          placeholder:
                                                            "Please fill in",
                                                        },
                                                        model: {
                                                          value:
                                                            well.APIGravity,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              well,
                                                              "APIGravity",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "well.APIGravity",
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "oilAnalysis",
                                                    label: "OIL ANALYSIS:",
                                                  },
                                                },
                                                [
                                                  !_vm.annualReview
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openPdfView(
                                                                well.oilAnalysis
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                well.oilAnalysis
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _c("file-upload", {
                                                        ref: "oilAnalysis",
                                                        refInFor: true,
                                                        on: {
                                                          onSuccess: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleFileSuccess(
                                                              $event,
                                                              well
                                                            )
                                                          },
                                                          onRemove: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleFileRemove(
                                                              $event,
                                                              well
                                                            )
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("pdfView", { ref: "pdfView" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }